import request from '@/utils/request'

export function listByCityArea(areaCode) {
    return request({
        module: 'center',
        url: '/openCompany/listByCityArea/' + areaCode,
        method: 'get',
        type: 'app'
    })
}


// WEBPACK FOOTER //
// ./src/api/center/openCompany.js